import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await axios.post(`${API}/newsletter`, {
        email,
        name: name || null
      });
      
      toast.success('Successfully subscribed to our newsletter!');
      setEmail('');
      setName('');
    } catch (error) {
      console.error('Newsletter signup error:', error);
      if (error.response?.status === 400) {
        toast.error('This email is already subscribed.');
      } else {
        toast.error('Failed to subscribe. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-24 bg-card relative overflow-hidden">
      <div className="absolute inset-0 cyber-grid opacity-20"></div>
      <div className="absolute inset-0" style={{
        background: 'radial-gradient(circle at 30% 50%, rgba(0, 255, 65, 0.1) 0%, transparent 40%), radial-gradient(circle at 70% 50%, rgba(255, 0, 255, 0.1) 0%, transparent 40%)'
      }}></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-20 h-20 bg-gradient-to-br from-primary to-pink rounded-full flex items-center justify-center mx-auto mb-6" style={{ boxShadow: '0 0 30px rgba(0, 255, 65, 0.5)' }}>
            <Mail className="text-inverse" size={40} />
          </div>
          
          <h2 className="heading-2 text-4xl md:text-5xl font-black uppercase mb-4">
            <span className="text-primary" style={{ textShadow: '0 0 15px var(--neon-green)' }}>Stay </span>
            <span className="text-blue" style={{ textShadow: '0 0 15px var(--neon-blue)' }}>Connected</span>
          </h2>
          
          <p className="body-medium text-secondary mb-8">
            Get exclusive updates, special offers, and be the first to know about new VR experiences and events!
          </p>
          
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
            <Input
              type="text"
              placeholder="Your name (optional)"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="flex-1 bg-page border-2 border-blue text-white"
            />
            <Input
              type="email"
              placeholder="Your email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-page border-2 border-pink text-white"
            />
            <Button 
              type="submit" 
              className="btn-primary px-8 font-bold"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Subscribing...' : 'Subscribe'}
            </Button>
          </form>
          
          <p className="text-muted text-xs mt-4">
            We respect your privacy. Unsubscribe anytime.
          </p>
        </div>
      </div>
    </section>
  );
};